import React, { useState } from 'react';
import { Box, IconButton } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import ClearIcon from '@mui/icons-material/Clear';
import dayjs from 'dayjs';

const DateRangeFilter = ({ onChange }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleStartDateChange = (date) => {
    setStartDate(date);
    onChange({
      document_date: {
        start: date ? dayjs(date).format('YYYY-MM-DD') : null,
        end: endDate ? dayjs(endDate).format('YYYY-MM-DD') : null,
      },
    });
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    onChange({
      document_date: {
        start: startDate ? dayjs(startDate).format('YYYY-MM-DD') : null,
        end: date ? dayjs(date).format('YYYY-MM-DD') : null,
      },
    });
  };

  const handleClearStartDate = () => {
    setStartDate(null);
    onChange({
      document_date: {
        start: null,
        end: endDate ? dayjs(endDate).format('YYYY-MM-DD') : null,
      },
    });
  };

  const handleClearEndDate = () => {
    setEndDate(null);
    onChange({
      document_date: {
        start: startDate ? dayjs(startDate).format('YYYY-MM-DD') : null,
        end: null,
      },
    });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box display="flex" gap={1}>
        <Box position="relative">
          <DatePicker
            label="Start Date"
            format="DD/MM/YYYY"
            value={startDate}
            onChange={handleStartDateChange}
            minDate={endDate ? endDate.subtract(1, 'year') : null}
            maxDate={endDate && endDate.isBefore(dayjs()) ? endDate : dayjs()}
            slotProps={{
              textField: {
                size: 'small',
                sx: { minWidth: 150 },
              },
            }}
          />
          {startDate && (
            <IconButton
              size="small"
              sx={{
                position: 'absolute',
                right: '28px',
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 1,
              }}
              onClick={handleClearStartDate}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
        <Box position="relative">
          <DatePicker
            label="End Date"
            format="DD/MM/YYYY"
            value={endDate}
            onChange={handleEndDateChange}
            minDate={startDate ? startDate : null}
            maxDate={startDate && startDate.add(1, 'year').isBefore(dayjs()) ? startDate.add(1, 'year') : dayjs()}
            slotProps={{
              textField: {
                size: 'small',
                sx: { minWidth: 150 },
              },
            }}
          />
          {endDate && (
            <IconButton
              size="small"
              sx={{
                position: 'absolute',
                right: '28px',
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 1,
              }}
              onClick={handleClearEndDate}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export default DateRangeFilter;
